import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "d-flex align-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_autocomplete = _resolveComponent("v-autocomplete");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_v_radio = _resolveComponent("v-radio");
    const _component_v_radio_group = _resolveComponent("v-radio-group");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_btn = _resolveComponent("v-btn");
    const _directive_btn_style = _resolveDirective("btn-style");
    return (_openBlock(), _createElementBlock("div", null, [
        _createCommentVNode(" 라이더 상태 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}worker_use_yn_type`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_autocomplete, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.workerUseYnTypeComputed,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.workerUseYnTypeComputed) = $event)),
                    items: _ctx.workerUseYnTypeOptions,
                    variant: "outlined",
                    placeholder: _ctx.$t('common.select_field_placeholder', { field: '상태' }),
                    "hide-details": "auto",
                    onKeyup: _cache[1] || (_cache[1] = ($event) => ($event.stopPropagation()))
                }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 라이더 유형 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}worker_type`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_autocomplete, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.workerTypeComputed,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.workerTypeComputed) = $event)),
                    items: _ctx.workerTypeOptions,
                    variant: "outlined",
                    placeholder: _ctx.$t('common.select_field_placeholder', { field: '유형' }),
                    "hide-details": "auto",
                    onKeyup: _cache[3] || (_cache[3] = ($event) => ($event.stopPropagation()))
                }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 카드 단말기 유형 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}card_device_type`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_autocomplete, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.cardDeviceTypeComputed,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.cardDeviceTypeComputed) = $event)),
                    items: _ctx.cardDeviceTypeOptions,
                    variant: "outlined",
                    "hide-details": "auto",
                    placeholder: _ctx.$t('common.select_field_placeholder', { field: '유형' }),
                    onKeyup: _cache[5] || (_cache[5] = ($event) => ($event.stopPropagation()))
                }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 락타임 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}order_delay_time_second`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_autocomplete, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.orderDelayTimeSecondComputed,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.orderDelayTimeSecondComputed) = $event)),
                    items: _ctx.orderDelayTimeSecondTypeOptions,
                    variant: "outlined",
                    "hide-details": "auto",
                    placeholder: _ctx.$t('common.select_field_placeholder', { field: '시간' })
                }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 접수 목록 제한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}accepted_order_view_limit_count`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_autocomplete, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.acceptedOrderViewLimitCountComputed,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.acceptedOrderViewLimitCountComputed) = $event)),
                    items: _ctx.acceptedOrderViewLimitCountTypeOptions,
                    variant: "outlined",
                    "hide-details": "auto",
                    placeholder: _ctx.$t('common.select_field_placeholder', { field: '건수' })
                }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" GPS 활성화 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}is_gps_on`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.isForceGpsOnComputed,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.isForceGpsOnComputed) = $event)),
                    name: "radio",
                    inline: "",
                    dense: ""
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredOptions, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: _ctx.$t(option.label),
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 공유배달 버튼 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}is_share_order_hidden`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.isSharedOrderHiddenComputed,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.isSharedOrderHiddenComputed) = $event)),
                    inline: "",
                    dense: ""
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exposureOptions, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: _ctx.$t(option.label),
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 배차취소 권한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}right_to_cancel_allocate`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.isPossibleToCancelAllocatedOrderComputed,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.isPossibleToCancelAllocatedOrderComputed) = $event)),
                    inline: "",
                    dense: ""
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilityOptions, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: _ctx.$t(option.label),
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 픽업예상시간 수정 권한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}right_to_calcel_allocated_order`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.isImpossibleToChangePickupExpectedAtComputed,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.isImpossibleToChangePickupExpectedAtComputed) = $event)),
                    inline: "",
                    dense: ""
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilityOptions, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: _ctx.$t(option.label),
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 도착지 주소 수정 권한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}right_to_change_drop_address`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.isPossibleToChangeDropAddressComputed,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.isPossibleToChangeDropAddressComputed) = $event)),
                    row: "",
                    dense: ""
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilityOptions, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: _ctx.$t(option.label),
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 결제수단 변경 권한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}right_to_change_payment_authority_type`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.changePaymentAuthorityTypeComputed,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.changePaymentAuthorityTypeComputed) = $event)),
                    row: "",
                    dense: ""
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorityOptions, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: _ctx.$t(option.label),
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 관제 권한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}right_to_control_change`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.isPossibleToControlComputed,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.isPossibleToControlComputed) = $event)),
                    row: "",
                    dense: ""
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilityOptions, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: _ctx.$t(option.label),
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 상점 송금 권한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}right_to_store_remittance`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.isPossibleToSendHubBaromoneyComputed,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.isPossibleToSendHubBaromoneyComputed) = $event)),
                    row: "",
                    dense: ""
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilityOptions, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: _ctx.$t(option.label),
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 라이더 수수료 그룹 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}worker_delivery_fee_group`),
            "is-combo-box": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                    modelValue: _ctx.workerDeliveryFeeGroupIdComputed,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.workerDeliveryFeeGroupIdComputed) = $event)),
                    filled: "",
                    disabled: "",
                    variant: "outlined",
                    dense: "",
                    placeholder: _ctx.$t(`${_ctx.lc}default_group_in_hub`),
                    "hide-details": "auto",
                    class: "grow"
                }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                    class: "ml-2",
                    onClick: _ctx.handleClickWorkerDeliveryFeeGroupId
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode("mdi-cog-outline")
                            ])),
                            _: 1 /* STABLE */,
                            __: [18]
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}change_worker_delivery_fee_group`)), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            info: true,
                            outlined: true,
                            "size-l": true
                        }
                    ]
                ])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 자동 차감 그룹 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}cash_auto_deduct_group`)
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_text_field, {
                        modelValue: _ctx.workerCashAutoDeductGroupIdComputed,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.workerCashAutoDeductGroupIdComputed) = $event)),
                        filled: "",
                        disabled: "",
                        variant: "outlined",
                        dense: "",
                        placeholder: _ctx.$t(`${_ctx.lc}default_group_in_hub`),
                        "hide-details": "auto",
                        class: "grow"
                    }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                        class: "ml-2",
                        onClick: _ctx.handleClickWorkerCashAutoDeductGroupId
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createTextVNode("mdi-cog-outline")
                                ])),
                                _: 1 /* STABLE */,
                                __: [19]
                            }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}change_cash_auto_deduct_group`)), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])), [
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                info: true,
                                outlined: true,
                                "size-l": true
                            }
                        ]
                    ])
                ])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])
    ]));
}
